import { tryCatch } from 'ramda';

export const isFunction = (value: any) => {
  return typeof value === 'function';
};

export const isNullFunction = (functionName: any, returnError: any) => {
  return tryCatch(
    () => functionName(),
    () => returnError
    // @ts-ignore
  )(functionName);
};
